import { render, staticRenderFns } from "./GeographicalAnalysis.vue?vue&type=template&id=d8035448"
import script from "./GeographicalAnalysis.vue?vue&type=script&lang=js"
export * from "./GeographicalAnalysis.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports